var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VContainer',[_c('h2',[_vm._v("HfMemberを登録できます。")]),_c('VRow',[_c('VCol',{attrs:{"cols":"12"}},[_c('HfMemberRegisterForm',{attrs:{"hfMemberParams":_vm.hfMemberParams}})],1)],1),_c('VBtn',{on:{"click":_vm.submit}},[_vm._v("Submit")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }